import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

import 'bootstrap/dist/css/bootstrap.min.css';

const Menu = props => (
      <Navbar fixed="top" bg="white" expand="lg" className="">
        <Container>
          <Navbar.Brand href="/"><img src="logo-coveris.svg" className="logo" alt="" /><img src="logo.png" className="logo-hdp" alt="" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/#about">O nas</Nav.Link>
              <Nav.Link href="/#offer">Oferta</Nav.Link>
              {/*<Nav.Link href="#news">Aktualności</Nav.Link>*/}
              {/*<Nav.Link href="/przetargi">Przetargi</Nav.Link>*/}
              <Nav.Link href="/rodo">RODO</Nav.Link>
              <Nav.Link href="/praca">Praca</Nav.Link>
              <Nav.Link href="/certyfikaty">Certyfikaty</Nav.Link>
              <Nav.Link href="/#contact">Kontakt</Nav.Link>
              <Nav.Link href="http://hadepol.com.pl/en"><img src="flag-en.png" alt="" className="language-switcher" /></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
);
  
  

export default Menu;
